export default "__VITE_ASSET__CggZp953__"